/**  MODIFIED COPY OF src/common-app/state/modules/engines/voice-mask/actions.ts TODO find way to reuse common code! */
import { TDOId } from '@common-modules/universal/models/Brands';
import {
  createGraphQLFailureAction,
  createGraphQLSuccessAction,
} from '@helpers/callGraphQLApi';
import { createAction } from '@reduxjs/toolkit';
import type { JobStatus } from 'veritone-types';

export const NOOP = 'noop';

/**
 * Begins the process of starting speaker-separation engine job.
 * Includes polling and loading results.
 */
export const PROCESS_ENGINE_REQUEST = createAction<{
  tdoId: TDOId;
  tdoName: string;
  payload: {
    targetId: string;
    url: string;
  };
}>('vtn/redact/engine/speaker-separation/PROCESS_ENGINE_REQUEST');

export const PROCESS_ENGINE_REQUEST_SUCCESS = createAction<{
  jobId: string;
  tdoId: TDOId;
}>('vtn/redact/engine/speaker-separation/PROCESS_ENGINE_REQUEST_SUCCESS');

export const processEngineRequestAction = ({
  tdoId,
  tdoName,
  targetId,
  url,
}: {
  tdoId: TDOId;
  tdoName: string;
  targetId: string;
  url: string;
}) =>
  PROCESS_ENGINE_REQUEST({
    tdoId,
    tdoName,
    payload: { targetId, url },
  });

export const processEngineRequestSuccessAction = ({
  tdoId,
  jobId,
}: {
  jobId: string;
  tdoId: TDOId;
}) => PROCESS_ENGINE_REQUEST_SUCCESS({ tdoId, jobId });

/**
 * Create engine job actions.
 */
export const CREATE_ENGINE_JOB = createAction<{
  tdoId: TDOId;
  tdoName: string;
  payload: { targetId: string; url: string };
}>('vtn/redact/engine/speaker-separation/CREATE_ENGINE_JOB');

export const CREATE_ENGINE_JOB_SUCCESS = createGraphQLSuccessAction<{
  createJob: {
    id: string;
    targetId: TDOId;
    status: string;
  };
}>('vtn/redact/engine/speaker-separation/CREATE_ENGINE_JOB_SUCCESS');

export const CREATE_ENGINE_JOB_FAILURE = createGraphQLFailureAction<
  any,
  { id: TDOId; tdoName: string },
  true
>('vtn/redact/engine/speaker-separation/CREATE_ENGINE_JOB_FAILURE');

export const createEngineJobAction = ({
  tdoId,
  tdoName,
  payload,
}: {
  tdoId: TDOId;
  tdoName: string;
  payload: { targetId: string; url: string };
}) => CREATE_ENGINE_JOB({ tdoId, tdoName, payload });

/**
 * Check job status actions.
 */
export const CHECK_JOB_STATUS = createAction<{
  jobId: string;
  tdoId: TDOId;
}>('vtn/redact/engine/speaker-separation/CHECK_JOB_STATUS');

export const CHECK_JOB_STATUS_SUCCESS = createGraphQLSuccessAction<{
  job: {
    id: string;
    targetId: TDOId;
    status: JobStatus;
  };
}>('vtn/redact/engine/speaker-separation/CHECK_JOB_STATUS_SUCCESS');

export const CHECK_JOB_STATUS_FAILURE = createGraphQLFailureAction(
  'vtn/redact/engine/speaker-separation/CHECK_JOB_STATUS_FAILURE'
);

export const checkJobStatusAction = ({
  tdoId,
  jobId,
}: {
  tdoId: TDOId;
  jobId: string;
}) => CHECK_JOB_STATUS({ tdoId, jobId });

/**
 * Polling actions.
 */
export const START_POLLING_ENGINE_RESULTS = createAction<{
  tdoId: TDOId;
  jobId: string;
}>('vtn/redact/engine/speaker-separation/START_POLLING_ENGINE_RESULTS');

export const STOP_POLLING_ENGINE_RESULTS = createAction<{
  tdoId: TDOId;
  jobId: string;
}>('vtn/redact/engine/speaker-separation/STOP_POLLING_ENGINE_RESULTS');

export const startPollingEngineResultsAction = ({
  tdoId,
  jobId,
}: {
  tdoId: TDOId;
  jobId: string;
}) => START_POLLING_ENGINE_RESULTS({ tdoId, jobId });

export const stopPollingEngineResultsAction = ({
  tdoId,
  jobId,
}: {
  tdoId: TDOId;
  jobId: string;
}) => STOP_POLLING_ENGINE_RESULTS({ tdoId, jobId });
